import { getCommonDefaultValues } from "../utils/getCommonDefaultValues";
import { formatDateOrNow } from "@app/utils/formatDate";
import { OPTIONS_YES_NO } from "./utils/constants";
import { toExponentialUppercase } from "@app/utils/functions";

export const getDefaultValuesIodo = (defaultPreloadValues?: any) => {
  const { currentPreparationIndex, currentCounting, currentCalculation } =
    defaultPreloadValues;

  const commonValues = getCommonDefaultValues(defaultPreloadValues);

  const currentCountingIndex =
    currentPreparationIndex?.countings?.[currentCounting?.index as number];

  const currentCalculationIndex =
    currentCountingIndex?.calculations[currentCalculation?.index as number];

  return {
    ...commonValues,

    //preparation
    end_date: formatDateOrNow(currentPreparationIndex?.end_date),
    yellow_precipitate_silver_nitrate:
      currentPreparationIndex?.yellow_precipitate_silver_nitrate !== null
        ? currentPreparationIndex?.yellow_precipitate_silver_nitrate
          ? OPTIONS_YES_NO[0]
          : OPTIONS_YES_NO[1]
        : undefined,
    violet_coloration:
      currentPreparationIndex?.violet_coloration !== null
        ? currentPreparationIndex?.violet_coloration
          ? OPTIONS_YES_NO[0]
          : OPTIONS_YES_NO[1]
        : undefined,
    planchette: currentPreparationIndex?.planchette || null,
    planchette_with_precipitate:
      currentPreparationIndex?.planchette_with_precipitate || null,
    preparation_performance: currentPreparationIndex?.performance || undefined,
    carrier_concentration:
      currentPreparationIndex?.carrier_concentration || undefined,
    scintillator_lot_number:
      currentPreparationIndex?.scintillator_lot_number || undefined,
    //counting
    counting_equipment: currentCountingIndex?.equipment || undefined,
    total_cpm_sample: currentCountingIndex?.total_cpm_sample || undefined,
    //calculation

    sampledAirVolumeSilicagel:
      currentPreparationIndex?.sampledAirVolumeSilicagel || "",
    calculation_date: formatDateOrNow(
      currentCalculationIndex?.calculation_date
    ),
    calculation_total_cpm_sample: currentCountingIndex?.total_cpm_sample || "",
    calculation_detector: currentCountingIndex?.detectors || [],
    calculation_performance:
      currentCalculationIndex?.performance ||
      currentPreparationIndex?.performance ||
      undefined,

    calculation_mg_torta:
      currentCalculationIndex?.mg_torta ||
      toExponentialUppercase(
        (Number(currentPreparationIndex?.planchette_with_precipitate) -
          Number(currentPreparationIndex?.planchette)) *
          1000,
        2
      ) ||
      undefined,
    calculation_fondo: currentCalculationIndex?.fondos || undefined,
    calculation_equipment:
      currentCalculationIndex?.equipment ||
      currentCountingIndex?.equipment ||
      undefined,
  };
};
